/* Tên đăng nhập, mật khẩu tạm, phân hệ. Dùng chung cho giao diện và dịch vụ API. */

export const ALL_MODS = ['docs', 'cash', 'labor', 'vb', 'tasks', 'org'] as const;
export type ModuleKey = (typeof ALL_MODS)[number] | 'users' | 'cal';

export const MOD_NAME: Record<string, string> = {
  docs: 'Hỗ trợ chứng từ', cash: 'Sổ quỹ tiền mặt', labor: 'Sổ lao động', vb: 'Quản lý văn bản',
  tasks: 'Quản lý công việc', org: 'Thông tin đơn vị', users: 'Quản lý người dùng', cal: 'Lịch',
};

/** Tên miền giả dùng làm email đăng nhập nội bộ (người dùng đăng nhập bằng tên đăng nhập, không bằng email). */
export const AUTH_EMAIL_DOMAIN = 'portal.local';

export const normUser = (s: unknown): string => String(s || '').trim().toLowerCase();
export const USERNAME_RE = /^[a-z0-9._-]{3,32}$/;
export const isValidUsername = (s: string): boolean => USERNAME_RE.test(s);
export const isValidEmail = (s: string): boolean => /^\S+@\S+\.\S+$/.test(s);
export const usernameToAuthEmail = (username: string): string => `${normUser(username)}@${AUTH_EMAIL_DOMAIN}`;

export const MIN_PASSWORD = 8;

/** Mật khẩu tạm 10 ký tự dễ đọc (không có 0/O/1/l/I) + '#' + 1 chữ số. */
export function tempPassword(rand: (n: number) => Uint8Array = n => globalThis.crypto.getRandomValues(new Uint8Array(n))): string {
  const a = 'ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnpqrstuvwxyz23456789';
  const r = rand(10);
  return Array.from(r, x => a[x % a.length]).join('') + '#' + (r[0] % 10);
}

/** Quản trị dùng được mọi phân hệ; người dùng thường theo danh sách được cấp. Công việc và Lịch ai cũng dùng được. */
export function canUseModule(user: { role?: string; modules?: string[] } | null | undefined, m: string): boolean {
  if (!user) return false;
  if (m === 'tasks' || m === 'cal') return true;
  if (m === 'users') return user.role === 'admin';
  return user.role === 'admin' || (user.modules || []).includes(m);
}

export interface NewUserInput {
  username: string; fullName: string; email: string; phone?: string; title?: string; role?: string; modules?: string[];
}

/** Trả về thông báo lỗi tiếng Việt, hoặc '' nếu hợp lệ. */
export function validateNewUser(i: NewUserInput): string {
  const un = normUser(i.username);
  if (!String(i.fullName || '').trim() || !String(i.email || '').trim() || !un) return 'Nhập đủ tên đăng nhập, họ tên và email.';
  if (!isValidUsername(un)) return 'Tên đăng nhập 3–32 ký tự: chữ thường không dấu, số, dấu chấm, gạch.';
  if (!isValidEmail(String(i.email).trim())) return 'Email không hợp lệ.';
  if (i.role && !['admin', 'user'].includes(i.role)) return 'Vai trò không hợp lệ.';
  if ((i.modules || []).some(m => !(ALL_MODS as readonly string[]).includes(m))) return 'Phân hệ không hợp lệ.';
  return '';
}
